module.exports = __webpack_public_path__ + "img/envelope.e3d7a912.png";